import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-workers-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './workers-page.component.html',
  styleUrl: './workers-page.component.css'
})
export class WorkersPageComponent {

}
